import { ReferralInfoProps } from '@components/ReferralInfo/ReferralInfo';
import GlobalIntlSingleton from '@setup/intl/GlobalIntlSingleton';

export const referralData: ReferralInfoProps[] = [
  {
    detail: GlobalIntlSingleton.intl.formatMessage({
      id: 'referral.copyAndShare',
    }),
    title: 1,
  },
  {
    detail: GlobalIntlSingleton.intl.formatMessage({
      id: 'referral.investGroups',
    }),
    title: 2,
  },
  {
    detail: GlobalIntlSingleton.intl.formatMessage({
      id: 'referral.stockOptions',
    }),
    title: 3,
  },
];
